import type { Styles } from 'common/types';
import type { CSSProperties } from 'react';

export const styles: Styles = {
  imageCard: {
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent !important',
    border: '1px solid',
    borderColor: 'divider',
    p: 0,
    cursor: 'grab',
    opacity: 0.999,
    transform: 'translateZ(0)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:active': { cursor: 'grabbing' },
  },
  dragOver: {
    transform: 'scale(1.05)',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },
  controlsBox: {
    position: 'absolute',
    bottom: 8,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 2,
    display: 'flex',
    gap: 0.5,
    p: 0.2,
    zIndex: 10,
  },
  orderBadge: {
    position: 'absolute',
    top: 8,
    left: 12,
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    filter: 'drop-shadow(0px 0px 2px #000)',
  },
};

export const nativeStyles: Record<string, CSSProperties> = {
  imageElement: {
    objectFit: 'cover',
    objectPosition: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 'inherit',
    display: 'block',
    pointerEvents: 'none',
  },
};
